<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { CarsListCar, SearchListCar } from '@autobid/ui/types/Car'
import { formatStartDate } from '@autobid/ui/utils/auctions/formatStartDate'
import { formatDate } from '@autobid/ui/utils/date/formatDate'
import { inject } from 'vue'

interface Props {
  car: CarsListCar | SearchListCar
}

defineProps<Props>()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')
</script>

<template>
  <p
    v-if="auctionStrapiData?.type === 'carSearch'"
    class="flex w-full text-sm md:w-1/4 md:flex-col md:flex-wrap md:text-base xl:w-auto"
  >
    <span
      v-if="car.auctionStartDate"
      class="block w-1/2 sm:w-1/3 md:mb-2 md:w-full"
    >
      {{ formatDate(car.auctionStartDate) }}<br>
      {{
        formatStartDate(car.auctionStartDate, {
          showFullDate: false,
          $t,
        })
      }}
    </span>
    <span class="block w-1/2 sm:w-1/3 md:w-full">
      {{ $t('cars-list.auction-no') }}: {{ car.auctionNumber }}<br>
      {{ $t('cars-list.catalog-no') }}: {{ car.catalogNumber }}
    </span>
  </p>
</template>
